import { useState } from "react";
import TaskListRwo from "./TaskListRwo";
import TaskListDetailsRwo from "./TaskListDetailsRwo";
import { TaskListRwo as TaskListRwoType } from "./types/dailyTaskRwo";

type View = "list" | "details";

const RwoListView = () => {

  const [view, setView] = useState<View>("list");
  const [selectedTask, setSelectedTask] = useState<TaskListRwoType | null>(null);

  const handleSelect = (task: TaskListRwoType) => {
    setSelectedTask(task);
    setView("details");
  };

  const handleBack = () => {
    setView("list");
    setSelectedTask(null);
  };

  const renderView = () => {
    switch(view) {
      case "list": return <TaskListRwo select={handleSelect}/>;
      case "details": return <TaskListDetailsRwo back={handleBack} task={selectedTask!}/>
      default: <TaskListRwo select={handleSelect} />;
      break;
    }
  };

  return (
    <div>
      {renderView()}
    </div>
  )
}

export default RwoListView